import roleService from '@/services/role.service';
import commonService from '@/services/common.service';
import config from '@/config/prod.env';

const actions = {
    async getAllRole({ dispatch }) {
        return await roleService.getAll();
    },

    // async getAllRole({ dispatch }) {
    //     return await roleService.getAll();
    // },

    // async getAllPagingRole({ dispatch }, params) {
    //     return await roleService.getAllPaging(params);
    // },
};

export const role = {
    namespaced: true,
    actions
};